module.exports = __webpack_public_path__ + "static/media/1.aeac9b60.png";